import {
  type Filter,
  FilterType,
  type FreeTextFilter,
  type ListFilter,
  type RangeFilter,
  type SchoolFilter,
  type StaticListFilter,
  type TreeFilter,
} from '../../filters/types/filters';

export const isListFilter = (
  filter: Filter | undefined
): filter is ListFilter => {
  return filter?.type === FilterType.LIST;
};

export const isStaticListFilter = (
  filter: Filter | undefined
): filter is StaticListFilter => {
  return filter?.type === FilterType.STATIC_LIST;
};

export const isFreeTextFilter = (
  filter: Filter | undefined
): filter is FreeTextFilter => {
  return filter?.type === FilterType.FREE_TEXT;
};

export const isTreeFilter = (
  filter: Filter | undefined
): filter is TreeFilter => {
  return filter?.type === FilterType.TREE;
};

export const isSchoolFilter = (
  filter: Filter | undefined
): filter is SchoolFilter => {
  return filter?.type === FilterType.SCHOOL;
};

export const isRangeFilter = (
  filter: Filter | undefined
): filter is RangeFilter => {
  return filter?.type === FilterType.RANGE;
};
